









import Vue from 'vue';

export default Vue.extend({
    computed: {
        appName() {
            return process.env.VUE_APP_NAME;
        },
        appVersion() {
            return process.env.VUE_APP_VERSION;
        },
    },
});
